import { createSlice } from '@reduxjs/toolkit'
import { fetchUserPermissions } from './thunks/fetchUserPermissionsThunk'
import { fetchUserTheme, Theme } from './thunks/fetchUserThemeThunks'

export type UserState = {
  loading: boolean
  theme: Theme,
  permissions: string[],
}

export const initialState: UserState = {
  loading: false,
  theme: {
    id: "",
    primaryColor: "",
    secondaryColor: "",
    logoFile: {
      id: "",
      fileName: ""
    }
  },
  permissions: [],
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action?.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUserPermissions.pending, state => {
        state.loading = true
      })
      .addCase(fetchUserPermissions.fulfilled, (state, action) => {
        state.loading = false
        state.permissions = action.payload
      })
      .addCase(fetchUserPermissions.rejected, state => {
        state.loading = false
      })
      .addCase(fetchUserTheme.pending, state => {
        state.loading = true
      })
      .addCase(fetchUserTheme.fulfilled, (state, action) => {
        state.loading = false
        state.theme = action.payload
      })
      .addCase(fetchUserTheme.rejected, state => {
        state.loading = false
      })
  },
})

export const { setTheme } = userSlice.actions

export default userSlice.reducer
